module.exports = __webpack_public_path__ + "img/savology-screen-10.ca9e2bee.png";